export default __webpack_public_path__ + "static/media/service-6.9c76491b.jpg";